/* eslint-disable */
export default {
  loading: 'Carregando...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
